import React from "react";

import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack from "@readai/pulse/components/Stack";

export interface TabsProps extends MuiTabsProps {
  /** If true, will not make the tabs shorter on smaller screens */
  disableMobileHeight?: boolean;
}

export const TabsContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.elevation.surface.raised,
  padding: theme.spacing(0, 1),
  borderBottom: "2px solid",
  borderColor: theme.palette.outline.default,
  "& .MuiTabs-root": { marginBottom: "-2px" },
  position: "relative",
  [theme.breakpoints.up("mobile")]: {
    padding: theme.spacing(0, 2.5),
  },
}));

const Tabs = styled<React.FC<TabsProps>>(MuiTabs, {
  shouldForwardProp: (propName) => propName !== "disableMobileHeight",
})(({ disableMobileHeight = false, theme }) => ({
  minHeight: "52px",
  "& .MuiTab-root.Mui-selected": {
    background: theme.palette.shades.primary[50],
  },

  [theme.breakpoints.down("mobile")]: {
    ...(!disableMobileHeight && {
      minHeight: "40px",
    }),
    "& .MuiTabs-flexContainer": {
      gap: theme.spaces.small,
    },
  },
}));

export default Tabs;
